import { services } from "../../portfolio";
import "./Services.css";
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import DevicesIcon from '@mui/icons-material/Devices';
import JavascriptIcon from '@mui/icons-material/Javascript';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Image from "./logo192.png"

const Services = () => {
  if (!services.length) return null;

  return (
    <section id="services" className="section services">
      <h2 className="section__title reveal">Services</h2>

      <div className="services__grid">
          <span className="card education reveal">
            <div className="overlay"></div>
            <div className="circle">
                <ViewQuiltIcon sx={{ fontSize: 60, backgroundColor: "transparent"}}/>
            </div>
            <p>Figma to Responsive Web</p>
        </span>
        <span className="card education reveal">
            <div className="overlay"></div>
            <div className="circle">
                <img src={Image} alt="React Logo"  style={{ width: 70, backgroundColor: "transparent"}}/>
            </div>
            <p>React JS and React Native</p>
        </span>
        <span className="card education reveal">
            <div className="overlay"></div>
            <div className="circle">
                <JavascriptIcon sx={{ fontSize: 60, backgroundColor: "transparent"}}/>
            </div>
            <p>MongoDB NodeJS Express</p>
        </span>
        <span className="card education reveal">
            <div className="overlay"></div>
            <div className="circle">
                <CloudDownloadIcon sx={{ fontSize: 60, backgroundColor: "transparent"}}/>
            </div>
            <p>Firebase Backend</p>
          </span>
      </div>
    </section>
  );
};

export default Services;
